import fetchCreator from "../utils/fetchCreator";

const client = new fetchCreator();

export const fetchShippers = () =>
  client.get(`clouds/shippers`).then((data: any) => {
    return data.data;
  });

export const fetchShippersCloudData = (cloudId: string) => {
  const url = `/clouds/${cloudId}?cloud_type=shippers`;

  return client.get(url).then((data: any) => {
    return data.data;
  });
};

export const fetchShipperRequests = () =>
  client.get("clouds/shippers/applications/pending").then((data: any) => {
    return data.data.shipper_requests;
  });

export const payShipper = (id: string) =>
  client
    .post("/billing/shippers/shipper/checkout", {
      shipper_id: id,
      status: "open",
    })
    .then((res: any) => res.data)
    .catch(console.error);

export const payOpenBusinessDebt = (
  solicitor_id: string,
  shippers_cloud_id: string
) =>
  client
    .post("/billing/business/cloud/checkout", {
      status: "open ",
      solicitor_id: solicitor_id,
      shippers_cloud_id: shippers_cloud_id,
    })
    .then((res: any) => res.data)
    .catch(console.error);

export const payPendingBusinessDebt = (
  bill_id: string,
  solicitor_id: string,
  shippers_cloud_id: string
) =>
  client
    .post("/billing/business/cloud/checkout", {
      bill_id: bill_id,
      status: "pending",
      solicitor_id: solicitor_id,
      shippers_cloud_id: shippers_cloud_id,
    })
    .then((res: any) => res.data)
    .catch(console.error);

const manageShipperRequest = ({ id, action }: any) =>
  client
    .patch("clouds/shippers/applications", { user_id: id, action })
    .then((response) => response);

export const acceptShipper = ({ id }: any) =>
  manageShipperRequest({ id, action: "accept" });

export const declineShipper = ({ id }: any) =>
  manageShipperRequest({ id, action: "decline" });

export const deactivateShipper = ({ id, action }: any) =>
  client
    .patch("clouds/shippers/applications", { user_id: id, action })
    .then((response) => response);

export const fetchShippersPayments = () =>
  client
    .get("/billing/shippers/account?augmented=true")
    .then((res: any) => res?.data);
